import {Pipe, PipeTransform} from "@angular/core";
import {EventState} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

@Pipe({
	name: "getEventStateStringForCustomer",
	pure: false,
	standalone: false,
})
export class GetEventStateStringForCustomerPipe implements PipeTransform {
	T = Translations;

	constructor(private _translate: TranslateService) {}

	transform(value: EventState): string {
		switch (value) {
			case EventState.Active:
				return this._translate.instant(this.T.CUSTOMER_EVENT_STATE_ACTIVE);
			case EventState.Archived:
				return this._translate.instant(this.T.CUSTOMER_EVENT_STATE_ARCHIVED);
			case EventState.Draft:
				return this._translate.instant(this.T.CUSTOMER_EVENT_STATE_DRAFT);
			case EventState.Planned:
				return this._translate.instant(this.T.CUSTOMER_EVENT_STATE_PLANNED);
			case EventState.Inactive:
				return this._translate.instant(this.T.CUSTOMER_EVENT_STATE_INACTIVE);
		}
	}
}
